import { render, staticRenderFns } from "./DiplomaStudentClassSave.vue?vue&type=template&id=8280ee4e&"
import script from "./DiplomaStudentClassSave.vue?vue&type=script&lang=js&"
export * from "./DiplomaStudentClassSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports